import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

//material ui components:
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';

//components
import FloatNumberFormatInput from '../../../components/float_number_input_formatter';
import IntNumberFormatInput from '../../../components/int_number_input_formatter';

const styles = theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: 290,
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        width: 141,
        marginBottom: 10,
        height: 105,
        borderBottom: `2px solid ${grey[500]}`,
        borderRight: `2px solid ${grey[500]}`,
    },
    pairContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    titlePaper: {
        fontSize: 13,
        fontWeight: '500',
        color: 'white',
        padding: '4px 2px 4px 12px',
        backgroundColor: grey[600],
        margin: 0,
    },
    textfield: {
        height: 100,
        margin: '0 auto',
        width: '85%',
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        }
    },
    inputprop: {
        margin: 'auto 0',
        padding: '8px 0',
        fontSize: 11,
        height: '50%',
    },
    righText:{
        textAlign: 'right'
    }
});

class RightSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            porcPartidasPack: !this.props.otrosDatosCierreSemanal.porcPartidasPack ? 0 : this.props.otrosDatosCierreSemanal.porcPartidasPack,
            pack2Partidas: !this.props.otrosDatosCierreSemanal.pack2Partidas ? 0 : this.props.otrosDatosCierreSemanal.pack2Partidas,
            conteoPersonas: !this.props.otrosDatosCierreSemanal.conteoPersonas ? 0 : this.props.otrosDatosCierreSemanal.conteoPersonas,
            aniversarios: !this.props.otrosDatosCierreSemanal.aniversarios ? 0 : this.props.otrosDatosCierreSemanal.aniversarios,
            ticketsEuros: !this.props.otrosDatosCierreSemanal.ticketsEuros ? 0 : this.props.otrosDatosCierreSemanal.ticketsEuros,
            promedioEuroMaq: !this.props.otrosDatosCierreSemanal.promedioEuroMaq ? 0 : this.props.otrosDatosCierreSemanal.promedioEuroMaq,
            averias: !this.props.otrosDatosCierreSemanal.averias ? 0 : this.props.otrosDatosCierreSemanal.averias,
            kids: !this.props.otrosDatosCierreSemanal.kids ? 0 : this.props.otrosDatosCierreSemanal.kids,
            kidsAniv: !this.props.otrosDatosCierreSemanal.kidsAniv ? 0 : this.props.otrosDatosCierreSemanal.kidsAniv,
            eurosKid: !this.props.otrosDatosCierreSemanal.eurosKid ? 0 : this.props.otrosDatosCierreSemanal.eurosKid,

        };
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //once we get the data:
        if (prevProps.otrosDatosCierreSemanal !== this.props.otrosDatosCierreSemanal) {
            this.setState({
                porcPartidasPack: !this.props.otrosDatosCierreSemanal.porcPartidasPack ? 0 : this.props.otrosDatosCierreSemanal.porcPartidasPack,
                pack2Partidas: !this.props.otrosDatosCierreSemanal.pack2Partidas ? 0 : this.props.otrosDatosCierreSemanal.pack2Partidas,
                conteoPersonas: !this.props.otrosDatosCierreSemanal.conteoPersonas ? 0 : this.props.otrosDatosCierreSemanal.conteoPersonas,
                aniversarios: !this.props.otrosDatosCierreSemanal.aniversarios ? 0 : this.props.otrosDatosCierreSemanal.aniversarios,
                ticketsEuros: !this.props.otrosDatosCierreSemanal.ticketsEuros ? 0 : this.props.otrosDatosCierreSemanal.ticketsEuros,
                promedioEuroMaq: !this.props.otrosDatosCierreSemanal.promedioEuroMaq ? 0 : this.props.otrosDatosCierreSemanal.promedioEuroMaq,
                averias: !this.props.otrosDatosCierreSemanal.averias ? 0 : this.props.otrosDatosCierreSemanal.averias,
                kids: !this.props.otrosDatosCierreSemanal.kids ? 0 : this.props.otrosDatosCierreSemanal.kids,
                kidsAniv: !this.props.otrosDatosCierreSemanal.kidsAniv ? 0 : this.props.otrosDatosCierreSemanal.kidsAniv,
                eurosKid: !this.props.otrosDatosCierreSemanal.eurosKid ? 0 : this.props.otrosDatosCierreSemanal.eurosKid,

            });
        };
    };


    handleValueChange = (event, field) => {

        this.setState({ ...this.state, [field]: event.target.value });
    };


    onBlur = (event, field) => {

        const value = !event.target.value ? 0 : parseInt(event.target.value);

        this.props.modifyFieldOtrosDatos(field, value);
    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.container}>
                <div className={classes.pairContainer}>
                    <div className={classes.paper}>
                        <p className={classes.titlePaper}>% Partidas Pack</p>
                        <TextField
                            disabled
                            placeholder={'0'}
                            className={classes.textfield}
                            InputProps={{
                                className: classes.inputprop,
                                classes:{ input: classes.righText},
                                inputComponent: FloatNumberFormatInput
                            }}
                            id={'porcPartidasPack'}
                            value={this.state.porcPartidasPack}
                            variant='outlined'
                        />
                    </div>
                    <div className={classes.paper}>
                        <p className={classes.titlePaper} variant="subtitle1">Pack 2 partidas</p>
                        <TextField
                            disabled
                            placeholder={'0'}
                            className={classes.textfield}
                            InputProps={{
                                className: classes.inputprop,
                                classes:{ input: classes.righText},
                                inputComponent: IntNumberFormatInput
                            }}
                            id={'pack2Partidas'}
                            value={this.state.pack2Partidas}
                            variant='outlined'
                        />
                    </div>
                </div>

                <div className={classes.pairContainer}>
                    <div className={classes.paper}>
                        <p className={classes.titlePaper}>Conteo Personas</p>
                        <TextField
                            disabled
                            placeholder={'0'}
                            className={classes.textfield}
                            InputProps={{
                                className: classes.inputprop,
                                classes:{ input: classes.righText},
                                inputComponent: IntNumberFormatInput
                            }}
                            id={'conteoPersonas'}
                            value={this.state.conteoPersonas}
                            variant='outlined'
                        />
                    </div>

                    <div className={classes.paper}>
                        <p className={classes.titlePaper} variant="subtitle1">Niños X Cumpleaños</p>
                        <TextField
                            disabled
                            placeholder={'0'}
                            className={classes.textfield}
                            InputProps={{
                                className: classes.inputprop,
                                classes:{ input: classes.righText},
                                inputComponent: FloatNumberFormatInput
                            }}
                            id={'kidsAniv'}
                            value={this.state.kidsAniv}
                            variant='outlined'
                        />
                    </div>
                </div>

                <div className={classes.pairContainer}>
                    <div className={classes.paper}>
                        <p className={classes.titlePaper}>Euros x Niño</p>
                        <TextField
                            disabled
                            placeholder={'0'}
                            className={classes.textfield}
                            InputProps={{
                                className: classes.inputprop,
                                classes:{ input: classes.righText},
                                inputComponent: FloatNumberFormatInput
                            }}
                            id={'eurosKid'}
                            value={this.state.eurosKid}
                            variant='outlined'
                        />
                    </div>

                    <div className={classes.paper}>
                        <p className={classes.titlePaper} variant="subtitle1">Tickets x Euros</p>
                        <TextField
                            disabled
                            placeholder={'0'}
                            className={classes.textfield}
                            InputProps={{
                                className: classes.inputprop,
                                classes:{ input: classes.righText},
                                inputComponent: FloatNumberFormatInput
                            }}
                            id={'ticketsEuros'}
                            value={this.state.ticketsEuros}
                            variant='outlined'
                        />
                    </div>
                </div>

                <div className={classes.pairContainer}>
                    <div className={classes.paper}>
                        <p className={classes.titlePaper}>Promedio € x Maq.</p>
                        <TextField
                            disabled
                            placeholder={'0'}
                            className={classes.textfield}
                            InputProps={{
                                className: classes.inputprop,
                                classes:{ input: classes.righText},
                                inputComponent: FloatNumberFormatInput
                            }}
                            id={'promedioEuroMaq'}
                            value={this.state.promedioEuroMaq}
                            variant='outlined'
                        />
                    </div>

                    <div className={classes.paper}>
                        <p className={classes.titlePaper} variant="subtitle1">Averías</p>
                        <TextField
                            disabled
                            placeholder={'0'}
                            className={classes.textfield}
                            InputProps={{
                                className: classes.inputprop,
                                classes:{ input: classes.righText},
                                inputComponent: IntNumberFormatInput
                            }}
                            id={'averias'}
                            value={this.state.averias}
                            variant='outlined'
                        />
                    </div>
                </div>

                <div className={classes.pairContainer}>
                    <div className={classes.paper}>
                        <p className={classes.titlePaper}>Cumpleaños</p>
                        <TextField
                            disabled
                            placeholder={'0'}
                            className={classes.textfield}
                            InputProps={{
                                className: classes.inputprop,
                                classes:{ input: classes.righText},
                                inputComponent: IntNumberFormatInput
                            }}
                            id={'aniversarios'}
                            value={this.state.aniversarios}
                            variant='outlined'
                        />
                    </div>

                    <div className={classes.paper}>
                        <p className={classes.titlePaper} variant="subtitle1">Niños</p>
                        <TextField
                            disabled
                            placeholder={'0'}
                            className={classes.textfield}
                            InputProps={{
                                className: classes.inputprop,
                                classes:{ input: classes.righText},
                                inputComponent: IntNumberFormatInput
                            }}
                            id={'kids'}
                            value={this.state.kids}
                            variant='outlined'
                        />
                    </div>
                </div>
            </div>

        );
    };
};


RightSection.propTypes = {
    otrosDatosCierreSemanal: PropTypes.object.isRequired,
    modifyFieldOtrosDatos: PropTypes.func.isRequired,
};


function mapStateToProps(state) {
    return {
        otrosDatosCierreSemanal: state.otrosDatosCierreSemanal.otrosdatos,
    };
};


export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(RightSection));